import type { RequestOnlineReportBody } from '@protector/entities/report/models';
import type { UUID } from '@protector/utils/types';
import axios from 'axios';
import axiosObservable from 'axios-observable';
import { map } from 'rxjs/operators';
import type {
  ReportInfo,
  ReportPayload,
  RequestOnlineReportInfo,
  RequestReportBody,
  RequestReportBodyApplicationStatistics
} from './report.models';

const protectorApiUrl = process.env.VITE_PROTECTOR_API_URL;

export const getPropertyReports = (propertyId: UUID, cursor?: string) => {
  let url = `${protectorApiUrl}/v1/properties/${propertyId}/reports`;
  if (cursor) {
    url += `?cursor=${cursor}`;
  }
  return axiosObservable.get<ReportPayload>(url).pipe(map(response => response.data));
};

export const downloadReport = async (reportId: UUID, propertyId: UUID) => {
  const response = await axios.get<string>(`${protectorApiUrl}/v1/properties/${propertyId}/reports/${reportId}/download-url`);
  return response.data;
};

export const requestReport = (body: RequestReportBody | RequestReportBodyApplicationStatistics) => {
  return axiosObservable.post<ReportInfo>(`${protectorApiUrl}/v1/reports`, body);
};

export const downloadOnlineReport = async (body: RequestOnlineReportBody) => {
  const response = await axios.post<RequestOnlineReportInfo>(`${protectorApiUrl}/v1/report/create`, body);
  return response.data;
};
